import { Header } from '@components/Header';
import { Tag } from '@components/core-ui/Tag';
import { useAsrProxyConsoleContext } from '../../providers/AsrProxyConsoleProvider';
import { DocsTab } from '../DocsTab';
import { DefaultsTab } from '../DefaultsTab';
import { JobsTab } from '../JobsTab';
import { ModelsTab } from '../ModelsTab';
import { PlaygroundTab } from '../PlaygroundTab';
import { TabsNav } from '../TabsNav';

export const Content = () => {
  const { tab, online, adapters } = useAsrProxyConsoleContext();

  return (
    <>
      <Header
        title="ASR Console"
        leftSideContent={[
          <TabsNav key="asr-console-tabs" />,
          <div key="asr-console-status" className="flex items-center gap-2">
            <Tag
              text={online ? 'Online' : 'Offline'}
              className={online ? 'tag--success-rounded' : 'tag--muted-rounded'}
            />
            {adapters.map((adapter) => (
              <Tag key={adapter} text={adapter} className="tag--muted-rounded" />
            ))}
          </div>,
        ]}
      />
      <main className={`min-h-[calc(100vh-120px)] p-2 px-8 ${tab === 'playground' ? 'pb-2' : 'pb-[70px]'}`}>
        {tab === 'playground' && <PlaygroundTab />}
        {tab === 'models' && <ModelsTab />}
        {tab === 'jobs' && <JobsTab />}
        {tab === 'defaults' && <DefaultsTab />}
        {tab === 'docs' && <DocsTab />}
      </main>
    </>
  );
};
